import * as React from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";

import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";

import FeatherIcon from "feather-icons-react";
import Button from "@mui/joy/Button";
import LinearProgress from "@mui/joy/LinearProgress";
import Divider from "@mui/joy/Divider";
import { useLoggedIn } from "../security/Security";

const PageLayout = ({ buttons, ...props }) => {
    const { config } = useLoggedIn();

    return (
        <React.Fragment>
            <PageTrail config={config}/>
            <PageHeader buttons={buttons} config={config}/>
            <br/>
            {props.children}
        </React.Fragment>
    );
};

export default PageLayout;

const PageHeader = ({ buttons = [], config }) => {
    const disabled = useNavigation().state === "loading";


    return (
        <Box sx={sxHeaderBox}>
            <Typography level="h1" fontSize="xl4" startDecorator={<FeatherIcon icon={config.getIcon()}/>}>
                {config.getText()}
            </Typography>

            <Box sx={{ flex: 999 }}/>

            <Box sx={{ display: "flex", gap: 1, "& > *": { flexGrow: 1 } }}>
                {buttons.map(item => createButton(item, disabled))}
            </Box>
        </Box>
    );
};

const createButton = (item, disabled) => {
    const decorator = <FeatherIcon icon={item.icon}/>;

    return (
        <Button color="neutral" disabled={disabled} key={item.text} onClick={item.onClick} startDecorator={decorator}
                variant="outlined">
            {item.text}
        </Button>
    );
};

const PageTrail = ({ config }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <Breadcrumbs separator="|" size="sm" sx={sxCrumb}>
                <Breadcrumb navigate={navigate} to="/" underline="none">
                    <FeatherIcon icon="home"/>
                </Breadcrumb>

                {addParentCrumb(config, navigate, location.pathname)}

                <Typography color="neutral" fontSize="inherit">
                    {config.getText()}
                </Typography>
            </Breadcrumbs>
        </Box>
    );
};

const Breadcrumb = ({ children, navigate, to, underline }) => (
    <Link color="neutral" fontSize="inherit" onClick={() => navigate(to)} underline={underline}>
        {children}
    </Link>
);

const addParentCrumb = (config, navigate, to) => {
    if (!config.getParent().isSubMenu()) {
        return null;
    }

    return (
        <Breadcrumb navigate={navigate} to={to} underline="hover">
            {config.getParent().getText()}
        </Breadcrumb>
    );
};

const sxCrumb = {
    "--Breadcrumbs-gap": "1rem", "--Icon-fontSize": "16px", fontWeight: "lg", color: "neutral.400", px: 0
};

const sxHeaderBox = {
    display: "flex", alignItems: "center", my: 1, gap: 1, flexWrap: "wrap", "& > *": {
        minWidth: "clamp(0px, (500px - 100%) * 999, 100%)", flexGrow: 1
    }
};